module.exports = __webpack_public_path__ + "static/home_01_mobile-456da27754f21b896c4440ab6c8fa1e5.webp";